export default "\n<!-- <app-sidebar></app-sidebar> -->\n<router-outlet></router-outlet>\n\n\n"